import { Suspense } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { CookieConsentProvider } from '@/contexts/CookieConsentContext'
import { CookieConsent } from '@/components/CookieConsent'
import { LanguageRouter } from '@/components/LanguageRouter'

function I18nFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-brand/20 border-t-brand" />
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <CookieConsentProvider>
        <Suspense fallback={<I18nFallback />}>
          <LanguageRouter />
        </Suspense>
        <CookieConsent />
      </CookieConsentProvider>
    </BrowserRouter>
  )
}
